import {Temporada, TemporadaJSON } from '../Temporada/Temporada';
export interface CategoriaJSON {
    cat_id: string;
    cat_nombre: string;
    cat_anio_desde: number;
    cat_anio_hasta: number;
    cat_duracion_periodo: number;
    cat_cant_periodos: number;
    cat_cant_periodos_extra: number;
    cat_duracion_periodo_extra: number;
    cat_activa: boolean;
    cat_temid: string;
    cat_pertenece_tira_inferiores: boolean;
    cat_duracion_intervalo_periodo: number;
    cat_duracion_intervalo_periodo_extra: number;
    cat_max_jugadores_x_planilla: number;
    cat_min_jugadores_x_planilla: number;
    temporada: TemporadaJSON | null;
}

export class Categoria {
    protected constructor(
    private id: string,
    private nombre: string,
    private anioDesde: number,
    private anioHasta: number,
    private duracionPeriodo: number,
    private cantPeriodos: number,
    private cantPeriodosExtra: number,
    private duracionPeriodoExtra: number,
    private activa: boolean,
    private temid: string,
    private perteneceTiraInferiores: boolean,
    private duracionIntervaloPeriodo: number,
    private duracionIntervaloPeriodoExtra: number,
    private maxJugadoresXPlanilla: number,
    private minJugadoresXPlanilla: number,
    private temporada: Temporada | null) {}

    static createFrom( id: string,
    nombre: string,
    anioDesde: number,
    anioHasta: number,
    duracionPeriodo: number,
    cantPeriodos: number,
    cantPeriodosExtra: number,
    duracionPeriodoExtra: number,
    activa: boolean,
    temid: string,
    perteneceTiraInferiores: boolean,
    duracionIntervaloPeriodo: number,
    duracionIntervaloPeriodoExtra: number,
    maxJugadoresXPlanilla: number,
    minJugadoresXPlanilla: number,
    temporada: Temporada | null) {
        return new this( id,
        nombre,
        anioDesde,
        anioHasta,
        duracionPeriodo,
        cantPeriodos,
        cantPeriodosExtra,
        duracionPeriodoExtra,
        activa,
        temid,
        perteneceTiraInferiores,
        duracionIntervaloPeriodo,
        duracionIntervaloPeriodoExtra,
        maxJugadoresXPlanilla,
        minJugadoresXPlanilla,
        temporada)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: Categoria) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: CategoriaJSON) {
        return Categoria.createFrom( entity.cat_id,
        entity.cat_nombre,
        entity.cat_anio_desde,
        entity.cat_anio_hasta,
        entity.cat_duracion_periodo,
        entity.cat_cant_periodos,
        entity.cat_cant_periodos_extra,
        entity.cat_duracion_periodo_extra,
        entity.cat_activa,
        entity.cat_temid,
        entity.cat_pertenece_tira_inferiores,
        entity.cat_duracion_intervalo_periodo,
        entity.cat_duracion_intervalo_periodo_extra,
        entity.cat_max_jugadores_x_planilla,
        entity.cat_min_jugadores_x_planilla,
        entity.temporada ? Temporada.fromJSON(entity.temporada) : null)
    }

    toJSON(): CategoriaJSON {
        return {
            cat_id: this.getId(),
            cat_nombre: this.getNombre(),
            cat_anio_desde: this.getAnioDesde(),
            cat_anio_hasta: this.getAnioHasta(),
            cat_duracion_periodo: this.getDuracionPeriodo(),
            cat_cant_periodos: this.getCantPeriodos(),
            cat_cant_periodos_extra: this.getCantPeriodosExtra(),
            cat_duracion_periodo_extra: this.getDuracionPeriodoExtra(),
            cat_activa: this.getActiva(),
            cat_temid: this.getTemid(),
            cat_pertenece_tira_inferiores: this.getPerteneceTiraInferiores(),
            cat_duracion_intervalo_periodo: this.getDuracionIntervaloPeriodo(),
            cat_duracion_intervalo_periodo_extra: this.getDuracionIntervaloPeriodoExtra(),
            cat_max_jugadores_x_planilla: this.getMaxJugadoresXPlanilla(),
            cat_min_jugadores_x_planilla: this.getMinJugadoresXPlanilla(),
            temporada: this.getTemporada() ? this.getTemporada()!.toJSON() : null
        }

    }

    getId(): string { return this.id; }

    getNombre(): string { return this.nombre; }

    getAnioDesde(): number { return this.anioDesde; }

    getAnioHasta(): number { return this.anioHasta; }

    getDuracionPeriodo(): number { return this.duracionPeriodo; }

    getCantPeriodos(): number { return this.cantPeriodos; }

    getCantPeriodosExtra(): number { return this.cantPeriodosExtra; }

    getDuracionPeriodoExtra(): number { return this.duracionPeriodoExtra; }

    getActiva(): boolean { return this.activa; }

    getTemid(): string { return this.temid; }

    getPerteneceTiraInferiores(): boolean { return this.perteneceTiraInferiores; }

    getDuracionIntervaloPeriodo(): number { return this.duracionIntervaloPeriodo; }

    getDuracionIntervaloPeriodoExtra(): number { return this.duracionIntervaloPeriodoExtra; }

    getMaxJugadoresXPlanilla(): number { return this.maxJugadoresXPlanilla; }

    getMinJugadoresXPlanilla(): number { return this.minJugadoresXPlanilla; }

    getTemporada(): Temporada | null{ return this.temporada; }

}

